import { useStore } from "@/stores/useStore";
import { useEffect, useMemo, useState } from "react";
import { config } from "@/config";

export const useVersionCheck = () => {
  const { appInfo } = useStore();
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);

  const isPreview = window.location.origin.includes("--pr");

  const latestAppVersion = useMemo(
    () => (isPreview ? appInfo?.previewVersion : appInfo?.liveVersion),
    [appInfo, isPreview]
  );
  const currentVersion = config.version;

  useEffect(() => {
    if (latestAppVersion && currentVersion) {
      const [major, minor, patch] = currentVersion.split(".");
      const [latestMajor, latestMinor, latestPatch] =
        latestAppVersion.split(".");

      if (
        parseFloat(latestMajor) > parseFloat(major) ||
        (parseFloat(latestMajor) === parseFloat(major) &&
          parseFloat(latestMinor) > parseFloat(minor)) ||
        (parseFloat(latestMajor) === parseFloat(major) &&
          parseFloat(latestMinor) === parseFloat(minor) &&
          parseFloat(latestPatch) > parseFloat(patch))
      ) {
        setNewVersionAvailable(true);
      }
    }
  }, [latestAppVersion, currentVersion]);

  return {
    newVersionAvailable,
    latestAppVersion,
    currentVersion,
  };
};
